import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from './firebase'

export type PersonalCreditRewardKind = 'CHECKLIST_COMPLETION'

type PersonalCreditRewardOptions = {
  amount?: number
  sourceId?: string
  workspaceId?: string
}

export const claimPersonalCreditReward = async (
  kind: PersonalCreditRewardKind,
  options: PersonalCreditRewardOptions = {},
) => {
  const call = httpsCallable<
    { kind: PersonalCreditRewardKind } & PersonalCreditRewardOptions,
    { credited: boolean; creditsAwarded: number; remaining: number; curseSuppressed?: boolean }
  >(firebaseFunctions, 'claimPersonalCreditReward')
  return (await call({ kind, ...options })).data
}
